module.exports = __webpack_public_path__ + "static/media/suggestion-marketing.4060d992.png";